import apiClient from '@api/apiClient';

export const FETCH_PRICES_PENDING = 'FETCH_PRICES_PENDING';
export const FETCH_PRICES_SUCCESS = 'FETCH_PRICES_SUCCESS';
export const FETCH_PRICES_FAILURE = 'FETCH_PRICES_FAILURE';

const fetchPricesPending = (serviceName) => ({
  type: FETCH_PRICES_PENDING,
  payload: { serviceName },
});

const fetchPricesSuccess = (serviceName, data) => ({
  type: FETCH_PRICES_SUCCESS,
  payload: { serviceName, data },
});

const fetchPricesFailure = (serviceName, error) => ({
  type: FETCH_PRICES_FAILURE,
  payload: { serviceName, error },
});

export const fetchPrices = (serviceName) => async (dispatch, getState) => {
  const { prices } = getState().prices;
  if (prices[serviceName]) {
    return;
  }

  dispatch(fetchPricesPending(serviceName));

  try {
    const response = await apiClient.get(`/services/${serviceName}/prices`);
    dispatch(fetchPricesSuccess(serviceName, response.data));
  } catch (error) {
    dispatch(fetchPricesFailure(serviceName, error.message));
  }
};
